// extracted by mini-css-extract-plugin
export default {"current-month":"components-market-snapshots-table-td-month-module__current-month"};